import type { ChangeEvent } from 'react'
import { Search, UserPlus, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'
import { Input } from '@/components/ui/Input'

interface ContactHeaderProps {
  searchTerm: string
  onSearchChange: (value: string) => void
  onAddClick: () => void
  friendRequestCount?: number
  onFriendRequestsClick?: () => void
}

export function ContactHeader({ 
  searchTerm, 
  onSearchChange, 
  onAddClick,
  friendRequestCount = 0,
  onFriendRequestsClick,
}: ContactHeaderProps) {
  const { t } = useTranslation()

  return (
    <div className="bg-white border-b border-gray-100 p-4">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold text-text-primary">
          {t('navigation.contacts')}
        </h1>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onFriendRequestsClick}
            className="relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-gray-200 bg-white text-primary transition-colors hover:bg-primary/5"
          >
            <Users className="h-4 w-4" />
            {friendRequestCount > 0 && (
              <span className="absolute -right-1 -top-1 min-w-[18px] rounded-full bg-error px-1.5 py-0.5 text-[10px] font-bold leading-none text-white">
                {friendRequestCount > 9 ? '9+' : friendRequestCount}
              </span>
            )}
          </button>
          <Button 
            variant="primary" 
            size="sm" 
            onClick={onAddClick}
          >
            <UserPlus className="h-4 w-4 mr-2" />
            {t('common.add')}
          </Button>
        </div>
      </div>

      <div className="relative">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-text-secondary" />
        <Input
          type="text"
          placeholder={t('contacts.searchContacts', 'Pesquisar contactos...')}
          value={searchTerm}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            onSearchChange(event.target.value)
          }}
          className="pl-10"
        />
      </div>
    </div>
  )
}
